import { ReactNode, useCallback } from "react";

import { BreadcrumbRoot as CommonBreadcrumbRoot, BreadcrumbPathResolver, BreadcrumbPathResolverHook } from "capitalrx-components-2.0/lib/shell";

import { useModulePathResolver } from "../hooks";

export { Breadcrumb, Breadcrumbs, BreadcrumbItem, BreadcrumbItems, useCurrentBreadcrumb } from "capitalrx-components-2.0/lib/shell";
export type { BreadcrumbProps, BreadcrumbsProps, BreadcrumbItemProps, BreadcrumbTitleSetter, BreadcrumbData, RegisteredBreadcrumbData } from "capitalrx-components-2.0/lib/shell";

/** The site configuration. */
declare const site: {

  /** The company name. */
  readonly companyName?: string;
} | undefined;

/**
 * Returns a resolver that namespaces breadcrumb paths to the owning module. This
 * hook runs at each breadcrumb's own tree position, so it observes the module
 * that registered the breadcrumb.
 * @returns The module-aware path resolver.
 */
const useModuleBreadcrumbPathResolver: BreadcrumbPathResolverHook = (): BreadcrumbPathResolver => {
  const resolve = useModulePathResolver();

  return useCallback((path: string): string => resolve(path), [resolve]);
};

/** The `BreadcrumbRoot` component properties. */
export interface BreadcrumbRootProps {

  /** The component children. */
  readonly children?: ReactNode;
}

/** The breadcrumb component. */
export const BreadcrumbRoot = (props: BreadcrumbRootProps): ReactNode => {
  const { children } = props;

  const handleActiveTitleChange = useCallback((activeTitle: string | null): void => {
    let title = site ? site.companyName : "Capital Rx";
    if (activeTitle) title += ` - ${activeTitle}`;
    if (title !== undefined) document.title = title;
  }, []);

  return (
    <CommonBreadcrumbRoot usePathResolver={useModuleBreadcrumbPathResolver} onActiveTitleChange={handleActiveTitleChange}>
      {children}
    </CommonBreadcrumbRoot>
  );
};
